import router from '../../router'
import { AUTH_COOKIE } from '../modules/user'
import { AUTH_API_COOKIE } from '../modules/user'
import jscookie from 'js-cookie'

const state = {
  buildingOwnership: null,
  buildingPlanAreas: null,
  depts: [],
  colleges: [],
  superCategories: [],
  categories: [],
  uses: [],
  types: [],
  classifications: [],
  programs: [],
  roomNames: []
}

const mutations = {

	setDepts(state, payload) {
		state.depts = payload
	},
	setColleges(state, payload) {
		state.colleges = payload
	},
	setBuildingOwnership (state, payload) {
		state.buildingOwnership = payload
	},

}

const getters = {
  	getDepartment : (state) => (deptID) => { 
   	 	return state.depts.find(dept => dept.deptID == deptID)
  	},

  	getCollege : (state) => (collegeID) => { 
   	 	return state.colleges.find(college => college.id == collegeID.toUpperCase())
  	},

 }

const actions = {
	
	updateLists ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/listupdate" ,
          {
            headers: {      'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                        		'impersonate' : getters.impersonateID,
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},

	refreshLists() {
		this.dispatch('fetchDepts')           // Used for Dept Search, more?
		this.dispatch('fetchColleges')
		this.dispatch('fetchCategories')      // Needed for Room Editing
		this.dispatch('fetchSuperCategories')
		this.dispatch('fetchTypes')           // Needed for Room Editing
		this.dispatch('fetchUses')            // Needed for Room Editing
		this.dispatch('fetchClassifications') // Needed for Room Editing
		this.dispatch('fetchPrograms')        // Needed for DV Program Edit
		this.dispatch('fetchBuildingDropdowns')
		this.dispatch('fetchRoomNames')
	},

	fetchBuildingDropdowns ({commit, getters}, payload) {
		//console.log("Action: fetchBuildingDropdowns ")		
		fetch('https://api.ba.arizona.edu/if/building/ownership', {      
			headers: { 
				'database' : getters.getDatabase(),
			    'content-type': 'application/json',
          'impersonate' : getters.impersonateID,
		}})
		.then(response => response.json())
		.then(data => { commit('setBuildingOwnership', data) 	})

		fetch('https://api.ba.arizona.edu/if/planareacodes', {      
			headers: { 
				'database' : getters.getDatabase(),
			    'content-type': 'application/json',
          'impersonate' : getters.impersonateID,
		}})
		.then(response => response.json())
		.then(data => state.buildingPlanAreas =  data)
	},

	// List of Colleges
	fetchColleges ({commit, getters}) {
		//console.log("Action: fetchColleges ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/colleges', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
                'impersonate' : getters.impersonateID,
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setColleges', data) // Commit mutation above
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Departments
	fetchDepts ({commit, getters}) {
		//console.log("Action: fetchDepts ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/depts', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        commit('setDepts', data) // Commit mutation above
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Categories
	fetchCategories ({commit, getters}) {
		//console.log("Action: fetchCategories ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/supercategories', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.superCategories = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of SuperCategories
	fetchSuperCategories ({commit, getters}) {
		//console.log("Action: fetchCategories ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/categories', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.categories = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Room Types
	fetchTypes ({commit, getters}) {
		//console.log("Action: fetchTypes ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/types', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.types = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Room Uses
	fetchUses ({commit, getters}) {
		//console.log("Action: fetchUses ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/uses', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.uses = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Room Uses
	fetchRoomNames ({commit, getters}) {
		//console.log("Action: fetchUses ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/roomnames', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.roomNames = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Room Classifications
	fetchClassifications ({commit, getters}) {
		//console.log("Action: fetchUses ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/classifications', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.classifications = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Programs
	fetchPrograms ({commit, getters}) {
		//console.log("Action: fetchPrograms ")
		return new Promise((resolve, reject) => {
			fetch('https://api.ba.arizona.edu/if/programs', {      
		      headers: {
		            'database' : getters.getDatabase(),
		            'content-type': 'application/json',
		            'impersonate' : getters.impersonateID
		      }})
		      .then(response => response.json())
		      .then(data => {
		        state.programs = data
		        resolve()
		      })
		      .catch(e => {
		        console.log(e);
		        reject()
		        return 
		    })
		})
	},

	// List of Accounts
	fetchAccounts ({commit, getters}, payload) {
			//console.log("Action: fetchAccounts " + payload)
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/accounts/', {      
				      headers: {
				      		'database' : getters.getDatabase(),
				          'content-type': 'application/json',
				          'impersonate' : getters.impersonateID
				      		},
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},

	// List of Abor Codes
	fetchAborCodes ({commit, getters}) {
			console.log("Action: fetchAborCodes ")
				return new Promise((resolve, reject) => {
					fetch('https://api.ba.arizona.edu/if/aborcodes', {      
				      headers: {
				      		'database' : getters.getDatabase(),
				            'content-type': 'application/json',
				            'impersonate' : getters.impersonateID
				      		},
				  	})
				      .then(response => response.json())
				      .then(data => {
				      	resolve(data)
				      })
				      .catch(e => {
				        console.log(e);
				        reject()
				        return e
				      })
			    })
	},
	
	updateBuildingReplacement ({commit, getters}, payload) {
		const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
		return new Promise((resolve, reject) => {
		fetch("https://api.ba.arizona.edu/if/update/blreplacement" ,
          {
            headers: {      'database' : getters.getDatabase(),
                            'Content-Type': 'application/json',
                            'apiEsriToken': apiEsriToken,
                            'impersonate' : getters.impersonateID
                            },
            method: "POST",
            body: JSON.stringify(payload)
          })
			.then(response => resolve(response.json()))
		})
	},
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/lists.js